import container from "../../libs/container/container";

const amdHomePartnersModule = (function () {
    const name = 'home__partners-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    }

    view.startup = function () {
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomePartnersHeaderBigCls, 'animate__bounce', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomePartnersLogoPrudenceCls, 'animate__zoomIn50P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomePartnersLogoDiscoveryCls, 'animate__zoomIn50P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomePartnersLogoClimateCls, 'animate__zoomIn50P', name, {
            dynamicPosHeight: true
        });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomePartnersLogoEosCls, 'animate__zoomIn50P', name, {
            dynamicPosHeight: true
        });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomePartnersLogoSpacer1Cls, 'animate__fadeInUp50P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomePartnersLogoSpacer2Cls, 'animate__fadeInDown50P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomePartnersLogoSpacer3Cls, 'animate__fadeInUp50P', name, {
            dynamicPosHeight: true
        });
    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdHomePartnersModule;